import { useState, useEffect, useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as _ from 'lodash';
import axios from 'axios';
import FireStoreParser from 'firestore-parser';
import { DataContext } from '../context/data-context';

export function useLatestCoverage(limit = 5) {
  const { endpointUrl, league } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(
        `${endpointUrl}data-endpoint/fotbollplay?channel=${league}&category=highlights`
      )
      .then((response) => {
        const parsedData = response?.data?.documents
          .map((item) => FireStoreParser(item))
          .map((item) => item.fields);
        setData(parsedData);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [endpointUrl, setData]);

  const videos = _.orderBy(data, 'date', 'desc').splice(0, limit);

  return [videos, loading, error];
}
